var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.47548,
    y: 0.592693,
    width: 9.09124,
    height: 9.09124,
    rx: 1.5,
    transform: "rotate(11.95 2.47548 0.592693)",
    stroke: "#E7E9F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4092,
    y: 1.43555,
    width: 9.09124,
    height: 9.09124,
    rx: 1.5,
    stroke: "#E7E9F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.43555,
    y: 14.4092,
    width: 9.09124,
    height: 9.09124,
    rx: 1.5,
    stroke: "#E7E9F1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.4102,
    y: 14.4092,
    width: 9.09124,
    height: 9.09124,
    rx: 1.5,
    stroke: "#E7E9F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubOutline);
export default __webpack_public_path__ + "static/media/hubOutline.cc9397cae3c4f60d62cceecc5875bc72.svg";
export { ForwardRef as ReactComponent };